<template>
  <div class="container-tight">
    <div
      style="
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
      "
    >
      <div style="display: flex;  justify-content: center; width: 100%">
        <img src="/logo.png" height="25" class="mb-4" />
      </div>
      <div class="card card-md" style="min-width: 450px">
        <div class="card-body">
          <h2 class="card-title mb-4">Create new account</h2>
          <div class="mb-3">
            <label class="form-label" style="text-align: left">
              Email address
            </label>
            <input
              v-model="user.email"
              @keyup.enter="initSignup()"
              type="email"
              class="form-control"
              placeholder="Enter email"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" style="text-align: left">Password</label>
            <input
              @keyup.enter="initSignup()"
              v-model="user.password"
              type="password"
              class="form-control"
              placeholder="Password"
              autocomplete="off"
            />
          </div>
          <Turnstile
            ref="turnstile"
            class="captcha-widget"
            :sitekey="sitekey"
            @verify="verify"
            @expired="expired"
          ></Turnstile>
          <div class="form-footer">
            <button
              :disabled="!user.email || !user.password || isRobot"
              type="submit"
              class="btn btn-primary w-100"
              :class="{ 'btn-loading': loading }"
              @keyup.enter="initSignup()"
              @click="initSignup()"
            >
              Create new account
            </button>
          </div>
        </div>
      </div>
      <div class="text-center text-muted mt-3">
        Already have account? <router-link to="/signin"> Sign in </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import Turnstile from '@/components/Turnstile.vue'
import { useRouter } from 'vue-router'

const $vue = getCurrentInstance()
const store = useStore()
const router = useRouter()

const sitekey = process.env.VUE_APP_TURNSTILE_SITEKEY

const user = ref({
	password: null,
	email: null,
	turnstile: null
})
const isRobot = ref(true)
const loading = ref(false)
const turnstile = ref(null)

// Check if dev mode is enabled
onMounted(() => {
	fetch('/api/robochecker')
		.then(response => response.json())
		.then(data => {
			if (data.Data && data.Data.bypass === true) {
				isRobot.value = false
				console.log('Dev mode enabled - captcha bypassed')
			}
		})
		.catch(err => {
			console.error('Failed to check dev mode:', err)
		})
})

function verify (response) {
	if (response) {
		isRobot.value = false
		user.value.turnstile = response
	} else {
		isRobot.value = true
		user.value.turnstile = null
	}
}

function expired () {
	isRobot.value = true
	user.value.turnstile = null
}

function resetTurnstile () {
	turnstile.value?.reset()
}

function initSignup () {
	loading.value = true
	if (isRobot.value) {
		$vue?.proxy.$swal.fire({
			icon: 'error',
			text: 'Please verify that you are not a robot!'
		})
		loading.value = false
		return
	}
	if (user.value.password.length < 8) {
		$vue?.proxy.$swal.fire({
			icon: 'error',
			text: 'Password should be at least 8 characters.'
		})
		loading.value = false
		return
	}
	if (user.value.email && user.value.password) {
		store.dispatch('signup', user.value)
			.then(() => {
				router.push('/email-verification')
				loading.value = false
			})
			.catch((err) => {
				resetTurnstile()
				$vue?.proxy.$swal.fire({
					icon: 'error',
					text: err.response.data.Data
				})
				loading.value = false
			})
	} else {
		$vue?.proxy.$swal.fire({
			icon: 'error',
			text: 'Please make sure to provide email and password.'
		})
		loading.value = false
	}
}
</script>
<style lang="css" scoped>
.captcha-widget {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
</style>
